import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AngularFirestore } from '@angular/fire/firestore';
import { limitItems } from 'assets/constants/records.limit';
import { InterfaceMesurement } from 'app/models/mesurement.model';

@Injectable({
  providedIn: 'root'
})
export class IndicatorService {

    url = 'https://d-troy-core.uc.r.appspot.com/';
  // url = 'http://localhost:8080/';

  constructor(
    protected firestore: AngularFirestore,
    protected http: HttpClient
  ) { }

  // create firebase id
  createId(): string {
    return this.firestore.createId();
  }

  getIndicator(indicatorId: string): Observable<any> {
    return this.firestore.collection('indicators').doc(indicatorId).valueChanges();
  }

  searchIndicator(indicatorName: string): Observable<any> {
    return this.firestore.collection('indicators', (query) => query.orderBy('indicator').startAt(indicatorName).endAt(indicatorName + '\uf8ff').limit(limitItems)).valueChanges();
  }

  getAllIndicators(lastItemId?: string): Observable<any> {
    return this.firestore.collection('indicators', (query) => lastItemId ? query.orderBy('indicator').startAfter(lastItemId).limit(limitItems) : query.orderBy('indicator').limit(limitItems)).valueChanges();
  }

  getActiveIndicators(body: any): Observable<any> {
    return this.http.post(this.url + 'indicators/getActiveIndicators', body, { observe: 'response' });
  }

  getIndicatorPeriod(body: any): Observable<any> {
    return this.http.post(this.url + 'indicators/getIndicatorPeriod', body, { observe: 'response' });
  }

  getIndicatorChartPeriod(body: any): Observable<any> {
    return this.http.post(this.url + 'indicators/getIndicatorChartPeriod', body, { observe: 'response' });
  }

  createMesurement(mesurement: InterfaceMesurement): Promise<any> {
    return this.firestore.collection(`mesurements`).doc(mesurement.id).set(mesurement);
  }

  getMesurement(indicatorId: string, yearNumber: number, weekNumber: number): Observable<any> {
    return this.firestore.collection(`mesurements`, (query) => query.limit(limitItems).orderBy('createdAt', 'desc').where('indicatorId', '==', indicatorId).where('yearNumber', '==', yearNumber).where('weekNumber', '==', weekNumber)).valueChanges();
  }

  getMesurementByMonth(indicatorId: string, yearNumber: number, monthNumber: number): Observable<any> {
    return this.firestore.collection(`mesurements`, (query) => query.limit(limitItems).orderBy('createdAt', 'desc').where('indicatorId', '==', indicatorId).where('yearNumber', '==', yearNumber).where('monthNumber', '==', monthNumber)).valueChanges();
  }

  getAllMesurementOfIndicator(indicatorId: string): Observable<any> {
    return this.firestore.collection('mesurements', (query) => query.orderBy('yearNumber').orderBy('weekNumber').where('indicatorId', '==', indicatorId)).valueChanges();
  }

  updateMesurement(mesurement: InterfaceMesurement): Promise<any> {
    return this.firestore.collection(`mesurements`).doc(mesurement.id).update(mesurement);
  }

  updateOrderIndicators(posc: number, id: string):Promise<any>{
    let data = {'order':posc}
    return this.firestore.collection(`indicators`).doc(id).update(data);
  }

  updateOrderAreas(posc: number, id: string):Promise<any>{
    console.log(posc,id)
    let data = {'areaOrder':posc}
    return this.firestore.collection(`indicators`).doc(id).update(data);
  }
}
